// Splits a CSV line at the first comma outside double quotes. If the quotes
// never close, falls back to the first comma so a stray quote doesn't drop the row.
function splitFirstComma(line) {
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    if (line[i] === '"') inQuotes = !inQuotes;
    else if (line[i] === ',' && !inQuotes) return [line.slice(0, i), line.slice(i + 1)];
  }
  const commaIdx = line.indexOf(',');
  return [line.slice(0, commaIdx), line.slice(commaIdx + 1)];
}

// Removes CSV quoting: a field wrapped in quotes loses them and "" becomes "
// (how Excel and Google Sheets escape a quote). A lone stray quote is dropped.
function unquote(field) {
  const f = field.trim();
  if (f.length >= 2 && f.startsWith('"') && f.endsWith('"')) return f.slice(1, -1).replace(/""/g, '"');
  return f.replace(/^"|"$/g, '');
}

// Parse CSV or tab/comma-delimited text into [{word, definition}]
export function parseText(text) {
  const lines = text.trim().split('\n');
  const rows = [];
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) continue;
    const tabIdx = line.indexOf('\t');
    const commaIdx = line.indexOf(',');
    let word, definition;
    if (tabIdx !== -1) {
      word = line.slice(0, tabIdx).trim();
      definition = line.slice(tabIdx + 1).trim();
    } else if (commaIdx !== -1) {
      [word, definition] = splitFirstComma(line).map(unquote);
    } else {
      continue;
    }
    if (word && definition) rows.push({ word, definition });
  }
  return rows;
}
